export const COMMENTS_PER_PAGE = 20;
export const LIKES_PER_PAGE = 20;
export const MEMBERS_PER_PAGE = 18;
export const POSTS_PER_PAGE = 20;
export const MAX_POSTS_PER_PAGE = 24;
export const MAX_POSTS_PER_PAGE_MOBILE = 5;
export const MAX_POSTS_PER_PAGE_FULL_POST = 3;
export const ARCHIVE_POSTS_PER_PAGE = 20;
export const MANAGED_POSTS_PER_PAGE = 40;
export const PAGINATION_TYPE_INFINITE_SCROLL = 0;
export const PAGINATION_TYPE_MULTIPLE_PAGES = 1;
//# sourceMappingURL=pagination.js.map